import React, { useContext, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import FormHalfCol from '../FormHalfCol/FormHalfCol';
import FormSection from '../FormSection/FormSection';
import Select from '../Select/Select';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from '../Input/Input';
import { Context } from '../Context/withContext';
import RequestResult from '../RequestResult/RequestResult';
import dayjs from 'dayjs';
import { getInstalmentWithDeposit } from '../../calculations/financeUtils';
import { getPeriodCalc } from '../../calculations/periodCalculation';

const schema = yup.object().shape({
  interest_rate: yup.string().required('Required'),
});

const VehiclePart4 = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  React.useEffect(() => {
    console.log('Part 4');
    console.log(
      generateOptions(formData.financeMatrix.term, 'months', 'months'),
    );
    console.log(
      generateOptions(
        formData.financeMatrix.term[term].deposit,
        'percentage',
        'percentage',
      ),
    );
    console.log(
      generateOptions(
        formData.financeMatrix.term[term].deposit[deposit].balloon,
        'percentage',
        'percentage',
      ),
    );
  }, []);

  const onSubmit = (data) => {
    const rateType = data.interest_rate;

    const financeDetails = {
      balloonPerc:
        formData.financeMatrix.term[term].deposit[deposit].balloon[balloon]
          .percentage,
      term: formData.financeMatrix.term[term].months,
      depositAmt: formData.financeMatrix.term[term].deposit[deposit].percentage,
      interestRate:
        rateType === 'L'
          ? formData.financeMatrix.term[term].deposit[deposit].balloon[balloon]
              .linkedRate
          : formData.financeMatrix.term[term].deposit[deposit].balloon[balloon]
              .fixedRate,
      rateType: rateType,
      price: formData.asset.price,
      amountToBeFinanced:
        formData.asset.price -
        (formData.financeMatrix.term[term].deposit[deposit].balloon[balloon]
          .percentage /
          100) *
          formData.asset.price,
      monthlyInstalment: formData.monthlyInstallment,
    };
    let temp = formData;
    formData.financeDetails = financeDetails;

    console.log('Part 4:', temp);

    setFormData(temp);
    setStepNumber(stepNumber + 1);
  };

  const [formData, setFormData] = useContext(FormDataContext);
  const [stepNumber, setStepNumber] = useContext(Context);

  const [term, setTerm] = useState(
    formData?.financeMatrix?.term?.length
      ? formData.financeMatrix.term.length - 1
      : 0,
  );
  const [deposit, setDeposit] = useState(
    formData?.financeMatrix?.term[term]?.deposit?.length
      ? formData.financeMatrix.term[term].deposit.length - 1
      : 0,
  );
  const [balloon, setBalloon] = useState(
    formData?.financeMatrix?.term[term]?.deposit[deposit]?.balloon?.length
      ? formData.financeMatrix.term[term].deposit[deposit].balloon.length - 1
      : 0,
  );
  const [rateType, setRateType] = useState(null);
  const [installment, setInstallment] = useState(0);

  const doInstallmentCalc = () => {
    if (!formData.financeMatrix) {
      return 0;
    }

    let depositAmt =
      (formData.financeMatrix.term[term].deposit[deposit].percentage / 100) *
      formData.asset.price;
    let intRate =
      rateType === 'L'
        ? formData.financeMatrix.term[term].deposit[deposit].balloon[balloon]
            .linkedRate
        : formData.financeMatrix.term[term].deposit[deposit].balloon[balloon]
            .fixedRate;
    let cashPrice = formData.asset.price;
    let balloonAmt =
      (formData.financeMatrix.term[term].deposit[deposit].balloon[balloon]
        .percentage /
        100) *
      formData.asset.price;
    let cal = new dayjs();
    let periodMap = getPeriodCalc(
      cal,
      new dayjs(),
      formData.financeMatrix.term[term].months,
    );

    let inst = getInstalmentWithDeposit(
      depositAmt,
      intRate,
      cashPrice,
      balloonAmt,
      periodMap,
    );
    return inst;
  };

  useEffect(() => {
    setInstallment(doInstallmentCalc());
  }, [term, deposit, balloon, rateType]);

  const generateOptions = (data, labelKey, valueKey) => {
    const options = {};
    data.forEach((item, index) => {
      options[index] = item[valueKey].toString();
    });
    return options;
  };

  return (
    <div>
      <RequestResult
        result={
          formData.financeResponse
            ? formData.financeResponse
            : formData.referredResponse
            ? 'REF'
            : 'E'
        }
      />

      {(formData.financeResponse === 'A' ||
        formData.referredResponse === true) && (
        <div className="mt-20">
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* <h2 className="text-3xl md:px-8 w-full uppercase font-bold my-12 text-suzBlue">
              Finance Options
            </h2> */}
            <FormSection>
              <FormHalfCol>
                <Select
                  setValue={setTerm}
                  label="Term"
                  register={register}
                  options={generateOptions(
                    formData.financeMatrix.term,
                    'months',
                    'months',
                  )}
                />
                <Select
                  setValue={setDeposit}
                  label="Deposit %"
                  register={register}
                  options={generateOptions(
                    formData.financeMatrix.term[term].deposit,
                    'percentage',
                    'percentage',
                  )}
                />
              </FormHalfCol>
              <FormHalfCol>
                <Select
                  setValue={setBalloon}
                  label="Balloon %"
                  register={register}
                  options={generateOptions(
                    formData.financeMatrix.term[term].deposit[deposit].balloon,
                    'percentage',
                    'percentage',
                  )}
                />
                <Select
                  setValue={setRateType}
                  register={register}
                  label="Interest Rate"
                  errorMessage={errors.interest_rate?.message}
                  options={{ F: 'Fixed', L: 'Linked' }}
                />
              </FormHalfCol>
            </FormSection>
            <p className="text-2xl text-center">
              Estimated monthly installment:
            </p>
            <p className="text-4xl text-suzGreen font-bold text-center mt-4">
              R{installment.toFixed(2)}
            </p>
            <div className="flex justify-center mt-16 w-full">
              <Input type="submit" label="Next" />
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default VehiclePart4;
